import React from "react";
import Header from "../../components/Header";
import FooterTwo from "../../components/Footer/FooterTwo";
import ScrollToTop from "../../components/ScrollTop";
import ErasmusMain from "./erasmus-main";
import Logo from "../../assets/images/logos/new-logo1.png";
import Breadcrumb from "../../components/Breadcrumb";


const ErasmusPlusGrants = () => {
  return (
    <>
      <Header
        parentMenu="page"
        menuCategoryEnable="enable"
        headerNormalLogo={Logo}
        headerStickyLogo={Logo}
      />

      <div class="react-wrapper">
        <div class="react-wrapper-inner">
        <Breadcrumb pageTitle={"Erasmus Plus"} />

          <ErasmusMain />

          {/* scrolltop-start */}
          <ScrollToTop />
          {/* scrolltop-end */}
        </div>
      </div>

      <FooterTwo />
    </>
  );
};

export default ErasmusPlusGrants;
